export const ASPECT_RATIO = 9 / 16;
export const height = 400;
export const width = height * ASPECT_RATIO;
